import { SearchActionTypes } from '../../../enums/ActionEnums';
export const searchActions = {
    createFetchWithoutProductsAction(value) {
        return {
            type: SearchActionTypes.FETCH_WITHOUT_PRODUCTS,
            payload: value,
        };
    },
    createFindAction(payload) {
        return {
            type: SearchActionTypes.FIND,
            payload,
        };
    },
    createAdobeAnalyticsSuccessProductAction() {
        return {
            type: SearchActionTypes.ADOBE_ANALYTICS_SUCCESSFULL_SEARCH_EVENT_PRODUCT,
        };
    },
    createAdobeAnalyticsSetSearchTermAction(payload) {
        return {
            type: SearchActionTypes.ADOBE_ANALYTICS_SET_SEARCH_TERM,
            payload,
        };
    },
};
